<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-wrench mr-2" />Kategori Kerusakan</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optKind"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Kategori Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data kategori kerusakan.
                </template>
                <template v-slot:cell(kind)="row">
                    {{ row.item.item_kind_name }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button v-if="isShowEditAndDelete" size="sm" variant="warning" class="mr-2" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button v-if="isShowEditAndDelete" size="sm" variant="danger" v-b-tooltip.hover.top title="Delete" @click="prepareDelete(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Kategori Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Kategori">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Jenis Barang">
                <multiselect v-model="input.kind"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optKind"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Kategori" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah kategori <strong>{{ activeItem.name }}</strong> ({{ activeItem.item_kind_name }})
            <b-form-group label="Nama Kategori" class="mt-4">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Jenis Barang">
                <multiselect v-model="edit.kind"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optKind"
                    disabled
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-delete" title="Delete Kategori" no-close-on-backdrop no-close-on-esc hide-footer>
            Anda yakin ingin menghapus kategori <strong>{{ activeItem.name }}</strong> ({{ activeItem.item_kind_name }})?
            <div class="mt-4 text-right">
                <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-delete')">
                    Batal
                </b-button>
                <b-button variant="danger" :disabled="isSubmitting" @click="confirmDelete">
                    {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnumPermissions from '@/shared/enum-permissions'
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                name: "",
                kind: null
            },

            input: {
                name: "",
                kind: null,
            },

            edit: {
                name: "",
                kind: null,
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Kategori", sortable: true },
                { key: "kind", label: "Jenis Barang", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getMasterKind = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        confirmCreate() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.input.kind == null) {
                return this.$helper.toastError(this, "Jenis barang tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan kategori kerusakan baru ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.input.name,
                item_kind_id: this.input.kind.id,
            }

            this.isSubmitting = true
            this.$axios.post("category", payload).then(res => {

                this.$helper.toastSuccess(this, "Kategori baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.name = ""
                this.input.kind = null
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.name = item.name
            this.edit.kind = {
                id: item.item_kind_id,
                name: item.item_kind_name
            }
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.edit.kind == null) {
                return this.$helper.toastError(this, "Jenis barang tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan perubahan kategori ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.edit.name,
                item_kind_id: this.edit.kind.id,
            }

            this.isSubmitting = true
            this.$axios.post("category/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "Data kategori berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.edit.name = ""
                this.edit.kind = null
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareDelete(item) {
            this.activeItem = item
            this.$bvModal.show("m-delete")
        },

        confirmDelete() {

            let isConfirmed = confirm("Apakah anda yakin ingin menghapus kategori kerusakan ini? Perubahan ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            this.isSubmitting = true

            this.$axios.delete("category/" + this.activeItem.id).then(res => {

                this.$helper.toastSuccess(this, "Kategori berhasil dihapus!")
                this.$bvModal.hide("m-delete")
                this.getItems()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if(this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                if(this.sortBy == 'kind') param += "&sortBy=item_kind_name"
                else param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("category" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("kategoriKerusakanFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

    },
    computed: {
        isShowEditAndDelete() {
            return this.$helper.checkRoleNumber(EnumPermissions.EDIT_DELETE_ADJ_KERUSAKAN.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("kategoriKerusakanFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("kategoriKerusakanFilter"))
        }
        this.init()
    }
}
</script>
